/**
 * Theme color-mode context (DNKADM-0266) — ported from the member app
 * (`dink-journix/src/context/theme-mode-context.ts`) so both apps share one
 * proven pattern. `themeMode` is the user's stated preference
 * (light/dark/system); `resolvedMode` is the concrete mode after resolving
 * `system` against the OS `prefers-color-scheme`.
 */
import { createContext, useContext } from 'react';

export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemeModeContextValue {
  themeMode: ThemeMode;
  resolvedMode: 'light' | 'dark';
  setThemeMode: (mode: ThemeMode) => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  themeMode: 'system',
  resolvedMode: 'light',
  setThemeMode: () => {},
});

export function useThemeMode(): ThemeModeContextValue {
  return useContext(ThemeModeContext);
}
